import { DefaultState } from 'store/types';

export const EDIT_LODGING_REQUEST_DATES_REQUEST = 'EDIT_LODGING_REQUEST_DATES_REQUEST';
export const EDIT_LODGING_REQUEST_DATES_SUCCESS = 'EDIT_LODGING_REQUEST_DATES_SUCCESS';
export const EDIT_LODGING_REQUEST_DATES_FAILURE = 'EDIT_LODGING_REQUEST_DATES_FAILURE';

export interface EditLodgingRequestDatesParams {
  id: string;
  fromDate: string;
  toDate: string;
  locationId: string;
  talentAgentEmail: string;
  doNotSendToGuest: boolean;
  doNotSendToCLC: boolean;
  corporateClientName?: string;
};

export interface EditRequestDatesFormParams {
  fromDate: Date | null;
  toDate: Date | null;
  locationId: string;
  talentAgentEmail: string;
  corporateClientName?: string;
}

export interface MassEditRequestDatesFormParams {
  fromDate: Date | null;
  toDate: Date | null;
  locationId: string;
  talentAgentEmail: string;
}

export interface EditLodgingRequestDatesData {
  requestsIds: string[];
  fromDate: string;
  toDate: string;
  locationId: string;
  talentAgentEmail: string;
  notSendNotificationToCLC?: boolean;
  notSendNotificationToGuest?: boolean;
};

export type EditLodgingRequestDatesState = DefaultState & {
  contents?: EditLodgingRequestDatesData;
};

interface EditLodgingRequestDatesRequest {
  type: typeof EDIT_LODGING_REQUEST_DATES_REQUEST;
};

interface EditLodgingRequestDatesSuccess {
  type: typeof EDIT_LODGING_REQUEST_DATES_SUCCESS,
  contents: EditLodgingRequestDatesData;
}

interface EditLodgingRequestDatesFailure {
  type: typeof EDIT_LODGING_REQUEST_DATES_FAILURE;
}

export type EditLodgingRequestDatesActionTypes = EditLodgingRequestDatesRequest | EditLodgingRequestDatesSuccess | EditLodgingRequestDatesFailure;
